import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { injectIntl } from 'react-intl';

import { black5 } from '../../../assets/shared-styles/general';
import EcInput from '../EcInput/EcInput';
import EcSelect from '../EcSelect/EcSelect';
import SubArrowIcon from '../Icons/SubArrowIcon';
import styles from './EcFilterTextSearch.styles';

class EcFilterTextSearch extends Component {
  constructor(props) {
    super(props);

    this.handleOnRelationChange = this.handleOnRelationChange.bind(this);
    this.handleOnScopeChange = this.handleOnScopeChange.bind(this);
  }

  handleOnTextChange(text) {
    this.props.onChange({ text, error: false });
  }

  handleOnRelationChange(contains) {
    this.props.onChange({ contains });
  }

  handleOnScopeChange(scope) {
    this.props.onChange({ scope });
  }

  renderTextSearchValues() {
    const { classes, text, error, intl } = this.props;

    return (
      <div className={classes.textValuesContainer}>
        <SubArrowIcon color={black5} />
        <EcInput
          input={{
            value: text || '',
            onChange: (e) => this.handleOnTextChange(e.target.value),
          }}
          placeholder={intl.formatMessage({
            id: 'EcFilterTextSearch.spaceSeparatedWordsPlaceholder',
            defaultMessage: 'space-separated list of words',
            description: 'Placeholder text for text search input',
          })}
          width="100%"
          error={error && (!text || !text.trim())}
        />
      </div>
    );
  }

  render() {
    const {
      classes,
      area,
      contains,
      scope,
      onRemoveClick,
      onFilterNameClick,
      intl,
    } = this.props;

    const searchWordsContainOptions = [
      {
        value: 'contains',
        label: intl.formatMessage({
          id: 'EcFilterTextSearch.containsOption',
          defaultMessage: 'contains',
          description: 'Search contains option label',
        }),
      },
      {
        value: 'does_not_contain',
        label: intl.formatMessage({
          id: 'EcFilterTextSearch.doesNotContainOption',
          defaultMessage: 'does not contain',
          description: 'Search does not contain option label',
        }),
      },
    ];

    const searchWordsScopeOptions = [
      {
        value: 'all_of_these_words',
        label: intl.formatMessage({
          id: 'EcFilterTextSearch.allOfTheseWordsOption',
          defaultMessage: 'all of these words',
          description: 'Search scope all words option label',
        }),
      },
      {
        value: 'any_of_these_words',
        label: intl.formatMessage({
          id: 'EcFilterTextSearch.anyOfTheseWordsOption',
          defaultMessage: 'any of these words',
          description: 'Search scope any words option label',
        }),
      },
      {
        value: 'exact_phrase',
        label: intl.formatMessage({
          id: 'EcFilterTextSearch.exactPhraseOption',
          defaultMessage: 'exact phrase',
          description: 'Search scope exact phrase option label',
        }),
      },
    ];

    return (
      <div className={classes.ecFilterFieldWrapper}>
        <div className={classes.ecFilterField}>
          <IconButton
            icon="x"
            onClick={onRemoveClick}
            text={intl.formatMessage({
              id: 'EcFilterTextSearch.removeFieldButton',
              defaultMessage: 'Remove Field',
              description: 'Remove field button accessibility text',
            })}
          />
          <Button
            tooltip={area.label}
            id={`field-tooltip-${area.value}`}
            text={area.label}
            onClick={onFilterNameClick}
            icon="chevron-down"
          />

          <hr className={classes.blueLine} />
          <div className={classes.fieldContainer}>
            <EcSelect
              value={contains}
              defaultValue={contains}
              options={searchWordsContainOptions}
              onChange={this.handleOnRelationChange}
            />
          </div>
          <hr className={classes.blueLine} />
          <div className={classes.fieldContainer}>
            <EcSelect
              value={scope}
              defaultValue={scope}
              options={searchWordsScopeOptions}
              onChange={this.handleOnScopeChange}
            />
          </div>
        </div>
        {this.renderTextSearchValues()}
      </div>
    );
  }
}

EcFilterTextSearch.propTypes = {
  entity: PropTypes.string.isRequired,
  area: PropTypes.object.isRequired,
  contains: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  scope: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onFilterNameClick: PropTypes.func.isRequired,
  error: PropTypes.bool,
  intl: PropTypes.object.isRequired,
};

export default injectSheet(styles)(injectIntl(EcFilterTextSearch));
